export default {
    cz: {
        title: 'Vložili jste do košíku',
    },
    sk: {
        title: 'Vložili ste do košíka',
    },
}
